import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AccessGuardService } from './access-guard.service';
import { NotificationService } from '@odin/odin-core';
import { RoleGuardService } from './role-guard.service';

@Injectable()
export class VirtualTerminalGuardService implements CanActivate {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private accessService: AccessGuardService,
    private roleGuardService: RoleGuardService,
  ) {}

  private getResolvedUrl(route: ActivatedRouteSnapshot): string {
    return route.pathFromRoot
      .map((v) => v.url.map((segment) => segment.toString()).join('/'))
      .join('/');
  }

  canActivate(
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.accessService.hasNewGrant('txn:Create') || this.roleGuardService.hasPermission('txn:Create')) return true;

    this.router.navigate(['/dashboard']);
    this.notificationService.AccessDeniedDialog('Virtual Terminal');
    return false;
  }
}
